import shallowProperty from './_shallowProperty.js';

// Internal helper to obtain the `byteLength` property of an object.
export default shallowProperty('byteLength');



//////////////////
// WEBPACK FOOTER
// ./~/_underscore@1.13.2@underscore/modules/_getByteLength.js
// module id = 238
// module chunks = 106